<template>
    <div :class="{
           '_e-FormText--disabled' : disabled
         }" class="_e-FormText">
        <FormLabel :item="item"/>
        <div class="_e-FormText__group">
            <input :class="{
                '_e-FormText__input' : true,
                '_e-FormText__input--error' : $v.$error
               }"
                   ref="FormText"
                   :disabled="disabled"
                   :value='valueInput'
                   @input="showBtn($event)"
                   @keyup.enter="update()"
                   type="text">
            <div class="_e-FormText__placeholder" v-if="!visibleNext">{{placeholder}}</div>
        </div>
        <FormButtonOK :visible="visibleNext && (!$v.$error || !extra.erreurBloquante)" @click="update()"/>
        <FormErreur :errors="$v.valueInput"/>
        <FormTextDisabled :disabled="disabled"/>
    </div>
</template>
<script>
  import FormButtonOK from '@/components/elements/FormButtonOK';
  import FormLabel from '@/components/elements/FormLabel';
  import FormTextDisabled from '@/components/elements/FormTextDisabled';
  import {alpha, alphaNum, email, numeric} from 'vuelidate/lib/validators';
  import FormErreur from '@/components/elements/FormErreur';

  import {texte} from '@/validations/texte';
  import {mapGetters} from 'vuex';

  export default {
    name: 'FormText',
    components: {FormErreur, FormTextDisabled, FormLabel, FormButtonOK},
    data() {
      return {
        visibleNext: false,
        valueInput: this.value,
        placeholder: 'Répondez ici...',
      };
    },
    props: {
      item: {type: [Array, Object], default: () => {}},
      value: {type: [String, Number, Object], default: ''},
      disabled: {type: Boolean, default: true},
      active: {type: Boolean, default: false},
      last: {type: Boolean, default: false},
    },
    validations() {
      let validation = {};
      if (this.item.validation) {
        validation = {
          'valueInput': {},
        };
        let validate = {};
        for (let valide of this.item.validation) {
          valide = valide.toLowerCase();
          if (valide == 'email') {
            validate = {...validate, email};
          }

          if (valide == 'texte') {
            validate = {...validate, texte};
          }

          if (valide == 'alpha') {
            validate = {...validate, alpha};
          }

          if (valide == 'alphaNum') {
            validate = {...validate, alphaNum};
          }

          if (valide == 'number') {
            validate = {...validate, numeric};
          }
        }
        validation.valueInput = validate;
      }
      return validation;
    },
    methods: {
      showBtn($event) {
        this.$v.$touch();
        this.valueInput = $event.target.value;
        if (this.valueInput.length > 0) {
          this.visibleNext = true;
        }
        else {
          this.visibleNext = false;
        }
      },
      update() {

        if (this.extra.requireAll) {
          if (this.valueInput.length <= 0) {
            return false;
          }
        }
        if (this.extra.erreurBloquante) {
          if (this.$v.$invalid) {
            return false;
          }
        }

        this.$emit('input', {
          id: this.item.id,
          title: this.item.title,
          value: this.valueInput,
        });

      },
      focus() {
        if (this.active === true && this.disabled !== true) {
          setTimeout(() => {
            this.$refs.FormText.focus();
          }, 200);
        }
      },
    },
    watch: {
      active() {
        this.focus();
      },
      disabled() {
        this.focus();
      },
    },
    computed: {
      ...mapGetters(['extra']),
    },
  };
</script>
<style scoped>
    ._e-FormText {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding-bottom: 100px !important;
    }

    ._e-FormText--disabled ._e-FormText__group * {
        opacity: 0.2;
        cursor: not-allowed;
        z-index: 200;
    }


    ._e-FormText__group {
        position: relative;
        width: calc(100% - 3rem);
        margin-left: 3rem;
    }

    ._e-FormText__input {
        box-sizing: content-box;
        position: relative;
        border: none;
        background: none;
        width: 100%;
        height: 3rem;
        line-height: 3rem;
        border-bottom: 1px solid rgba(255, 255, 255, 0.4);
        margin-bottom: 15px;
        text-align: left;
        color: white;
        font-size: 2rem;
        padding: 5px 0;
        z-index: 50;
    }


    ._e-FormText__input--error {
        border-bottom: 1px solid rgba(233, 11, 22, 0.67);
        color: rgba(255, 0, 0, 0.71);
    }

    ._e-FormText__input._e-FormText__input--error:focus {
        border-bottom: 1px solid rgba(233, 11, 22, 0.67);
    }

    ._e-FormText__placeholder {
        box-sizing: content-box;
        position: absolute;
        z-index: 10;
        text-align: left;
        top: 0;
        left: 0;
        font-size: 2rem;
        height: 3rem;
        line-height: 3rem;
        padding: 5px 0;
        color: rgba(255, 255, 255, 0.4);
        width: 100%;
    }

    ._e-FormText__input:focus {
        outline: none;
        border-bottom: 1px solid transparent;
    }
</style>